import React, {useState} from 'react';
import {useParams} from "react-router-dom";
import ExtractForm from "../../../components/data_products/extracts/ExtractForm";
import {useDifactoBucket} from "../../../components/utils";
import {Icon, Title} from "../../../components/components";
import FormButton from "../../../components/forms/FormButton";
import {Button} from "react-bootstrap";
import {useControlledTabs} from "../../../components/Tabs";
import {useTranslation} from "react-i18next";
import { useGetExtractAggregationOptionsQuery, useGetExtractQuery, useRunExtractMutation } from '../../../api/extractApiSlice';
import {useGetAudiencesQuery} from "../../../api/audienceApiSlice";
import useRunExtract from '../../../components/data_products/useRunExtract';

export default function Extract(props) {
  const { t } = useTranslation();
  const { extractId } = useParams();
  const { data: extract, isSuccess } = useGetExtractQuery(extractId)
  const [run] = useRunExtractMutation()
  const bucket = useDifactoBucket();
  const [tabProps, setActiveTab] = useControlledTabs("extract", props)
  const { data: aggregationOptions = [] } = useGetExtractAggregationOptionsQuery()
  const { data: audiences = [] } = useGetAudiencesQuery()
  const {extractRuning, runExtract} = useRunExtract( { extractId, extract, onStart: ()=>(run(extractId)), onStarted: ()=>(setActiveTab("extract_monitor")) })

  if( !isSuccess ) { return (<></>) }
  return (
    <>
      <Title main={t("menu.extracts")} sub={extract.name} backPath="/extracts" group={false}>
        <FormButton edit state={{activeTab: tabProps.active}}/>
        <Button key="run" onClick={runExtract} disabled={extractRuning}>
          <Icon icon={extractRuning ? 'loading' : 'play'} text={t("extract.run")} />
        </Button>
      </Title>
      <ExtractForm
        disabled
        extract={extract}
        aggregationOptions={aggregationOptions}
        audiences={audiences}
        bucket={bucket}
        tabProps={tabProps}/>
    </>
  )
}
